import { CONTACT_SUPPORT_URL } from '@utils/constants/mock-exam.constants';
import React from 'react';

const MockExamClosed = () => {
  return (
    <>
      <p className="text-neutral-pencil mb-8">
        Thank you for your interest in our Mock Exams! We hope to see you in our
        future events.
      </p>
      <p className="text-neutral-pencil">
        Need help?{' '}
        <a
          href={CONTACT_SUPPORT_URL}
          target="_blank"
          className="text-primary-apricot underline font-medium"
          rel="noreferrer"
        >
          Contact our support team
        </a>
      </p>
    </>
  );
};

export default MockExamClosed;
